<header>
    <div class="background-header"></div>
</header>
